module.exports = __webpack_public_path__ + "static/img/welcome-to-carr-challenge.d1615953.jpg";